import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";


export const chatapi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,
    mode: "cors"
}),
  reducerPath: "index",
  tagTypes: [],
  endpoints: (build) => ({
    postLogin: build.mutation({
      query: (payload) => ({
        url: "auth/login",
        method: "POST",
        body: payload,
      }),
    }),
    postSignUp: build.mutation({
      query: (payload) => ({
        url: "auth/signup",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  usePostLoginMutation,
  usePostSignUpMutation,
} = chatapi;
